import { Component } from '@app/models/component';
import { Tab } from '@app/models/tab';
import { User } from '@app/models/user';

export class UserTabComponentConfiguration {
  public Id: number;
  public User?: User;
  public UserUpnId: string;
  public Tab?: Tab;
  public TabId: string;
  public Component?: Component;
  public ComponentId: string;
  public ComponentConfigurations?: { [key: string]: any; };
  public Hidden?: boolean;
  public Order: number;

  constructor(opt?: Partial<UserTabComponentConfiguration>) {
    Object.assign(this, opt);
  }
}
